import { IMessageV2Schema } from '@cian/chats-api';

// eslint-disable-next-line import/no-cycle
import { ERequestApiStatus } from './appState';
import { TRoute } from './route';
import { IChatDataInListSchema, EType } from '../repositories/chats/entities/chat/ChatDataInListSchema';
import { IEnrichedChatSchema } from '../repositories/chats/entities/chat/EnrichedChatSchema';
import { IOfferSchema } from '../repositories/chats/entities/offer/OfferSchema';
import { ISyncChatSchema } from '../repositories/chats/entities/synchronization/SyncChatSchema';
import {
  EStatus as EStatusSyncChatSchema,
  EFilterBy as EFilterBySyncChatSchema,
} from '../repositories/chats/entities/synchronization/V2ScrollSynchronizationRequestSchema';

// Количество чатов на 1 страницу
const CHATS_ON_PAGE_LIMIT = 25;

// TODO при переходе на все версии ручек - нужно этот фикс удалить
export type TChatDataInListSchema = Omit<IChatDataInListSchema, 'message'> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;
  lastMessage?: IMessageV2Schema;
  botId?: number | null;
  isStarred: boolean;
};

export type TChatDataInListResponse = Omit<IChatDataInListSchema, 'data'> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;
};

// IChatListResponseSchema
export type TChatListResponse = {
  chats: TChatDataInListResponse[];
};

export type TSingleChatV1Response = Omit<IEnrichedChatSchema, 'data'> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
};

type TChatInListSchema = TChatDataInListSchema;

type TChatListState = {
  status: ERequestApiStatus;
  currentPage: number;
  currentRoute: TRoute;
  chats: TChatInListSchema[];
  allChatsLoaded?: boolean;
  timestamp?: number;
  timestampSpam?: number;
  timestampArchive?: number;
  timestampStarred?: number;
  movedToSpamChatIds: string[];
  removedFromSpamChatId?: string;
  movedToArchiveChatIds: string[];
  removedFromArchiveChatId?: string;
  notClearCurrentOpenedChatId?: boolean;
  isChangeListActive: boolean;
  isLoadProgress: boolean;
  isFirstLoad: boolean;
  selectedChats: string[];
};

export { CHATS_ON_PAGE_LIMIT, EType as EChatInListType, EStatusSyncChatSchema, EFilterBySyncChatSchema };
export type {
  TChatInListSchema,
  TChatListState,
  ISyncChatSchema as TSingleChatV2Response,
  IOfferSchema as TSingleChatV2Offer,
};
